// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"421":"77b8b15f","443":"b81e35fd"}[chunkId] + ".chunk.css";
};